import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoldUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4697 5.21967C11.7626 4.92678 12.2374 4.92678 12.5303 5.21967L15.7803 8.46967C16.0732 8.76256 16.0732 9.23744 15.7803 9.53033C15.4874 9.82322 15.0126 9.82322 14.7197 9.53033L12.75 7.56066V14.25C12.75 14.6642 12.4142 15 12 15C11.5858 15 11.25 14.6642 11.25 14.25V7.56066L9.28033 9.53033C8.98744 9.82322 8.51256 9.82322 8.21967 9.53033C7.92678 9.23744 7.92678 8.76256 8.21967 8.46967L11.4697 5.21967Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 17.25C11.0858 17.25 10.75 17.5858 10.75 18C10.75 18.4142 11.0858 18.75 11.5 18.75H12.5C12.9142 18.75 13.25 18.4142 13.25 18C13.25 17.5858 12.9142 17.25 12.5 17.25H11.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.75 18C2.75 17.5858 3.08579 17.25 3.5 17.25H4.5C4.91421 17.25 5.25 17.5858 5.25 18C5.25 18.4142 4.91421 18.75 4.5 18.75H3.5C3.08579 18.75 2.75 18.4142 2.75 18Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 17.25C15.0858 17.25 14.75 17.5858 14.75 18C14.75 18.4142 15.0858 18.75 15.5 18.75H16.5C16.9142 18.75 17.25 18.4142 17.25 18C17.25 17.5858 16.9142 17.25 16.5 17.25H15.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 18C6.75 17.5858 7.08579 17.25 7.5 17.25H8.5C8.91421 17.25 9.25 17.5858 9.25 18C9.25 18.4142 8.91421 18.75 8.5 18.75H7.5C7.08579 18.75 6.75 18.4142 6.75 18Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 17.25C19.0858 17.25 18.75 17.5858 18.75 18C18.75 18.4142 19.0858 18.75 19.5 18.75H20.5C20.9142 18.75 21.25 18.4142 21.25 18C21.25 17.5858 20.9142 17.25 20.5 17.25H19.5Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgFoldUp;
